import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface MyAirportsPrivacyPolicyResponse {
  id: number | string;
  tab_title_english_1: string;
  tab_title_malay_1: string;
  tab_title_mandarin_1: string;
  tab_title_english_2: string;
  tab_title_malay_2: string;
  tab_title_mandarin_2: string;
  description_english_tab_1: string;
  description_malay_tab_1: string;
  description_mandarin_tab_1: string;
  description_english_tab_2: string;
  description_malay_tab_2: string;
  description_mandarin_tab_2: string;
  created_by?: string;
  last_modified_by?: string;
}

// Edit API call
const fetchMyAirportsPrivacyPolicy = async (): Promise<any> => {
  // if (!id) {
  //   return null;
  // }
  const response: any = await axios.get(`${centralizedHost}/api/my-airports-privacy-policy`);
  return response.data[0];
};

const useMyAirportsPrivacyPolicy = (
  // id: string,
  options?: UseQueryOptions<MyAirportsPrivacyPolicyResponse, DefaultError, MyAirportsPrivacyPolicyResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<MyAirportsPrivacyPolicyResponse, DefaultError> => {
  return useQuery<MyAirportsPrivacyPolicyResponse, DefaultError, MyAirportsPrivacyPolicyResponse, QueryKey>(
    {
      queryKey: ["myAirportsPrivacyPolicy"],
      enabled: false,
      queryFn: () => {
        return fetchMyAirportsPrivacyPolicy();
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useMyAirportsPrivacyPolicy };
